import './combo-box_polyfills.js';

export default {
    autoDirection: {
        mounted(el, binding) {
            binding.value(el);
        },
    },
    keyboardNavigation: {
        beforeMount(el, binding) {
            el.keyListener = function (event) {
                binding.value(event);
            };
            document.addEventListener('keydown', el.keyListener);
        },
        unmounted(el) {
            document.removeEventListener('keydown', el.keyListener);
        },
    },
    clickOutside: {
        beforeMount(el, binding) {
            el.clickOutsideEvent = event => {
                if (el === event.target || el.contains(event.target)) {
                    // Pass
                } else {
                    const getDigitOnlyId = value => value && value.match(/[\d]+/) && value.match(/[\d]+/)[0];
                    const comboBoxId = getDigitOnlyId(binding.instance.resultsId);
                    const tag = event.target.closest('[class*=mds-combo-box__selection-tag]');
                    const tagId = tag && getDigitOnlyId(tag.id);

                    if (!(tagId && comboBoxId === tagId)) {
                        binding.value();
                    }
                }
            };

            document.body.addEventListener('click', el.clickOutsideEvent);
        },
        unmounted(el) {
            document.body.removeEventListener('click', el.clickOutsideEvent);
        },
    },
};
